export default __webpack_public_path__ + "location.bb1191d0.svg";